<ng-container #shopCard>
  <app-destination-card-template-variant
    [title]="destination.name"
    [distance]="destination.distanceTo"
    [operatingDays]="destination.operatingDays"
    [status]="status"
    [borderShadow]="borderShadow"
    [suggested]="suggested"
    [showMemberDiscount]="showMemberDiscount$ | async"
    (close)="onClose()"
    [isActive]="isActive"
  >
    <div content>
      <ion-row class="destination-type">
        <ion-col>
          <app-destination-type-variant [destination]="destination"></app-destination-type-variant>
        </ion-col>
      </ion-row>
      <ion-row class="destination-address ion-align-items-center ion-margin-bottom">
        <ion-col>
          <aaa-text class="line1">{{addressLine1}}</aaa-text>
          <aaa-text class="line2">{{addressLine2}}</aaa-text>
        </ion-col>
      </ion-row>
    </div>
    <div footer>
      <ng-content select="[footer]"></ng-content>
    </div>
  </app-destination-card-template-variant>
</ng-container>

